module.exports = __webpack_public_path__ + "static/media/kcc-token-logo.21d93707.png";